import { ListIdeasQueryVariables, GetIdeaSummaryInput, GetIdeaSummaryMutationVariables, DeleteIdeaCategoryMutationVariables, CreateIdeaCategoryMutationVariables, CreateIdeaHashtagMutationVariables, DeleteIdeaHashtagMutationVariables, CreateIdeaScoreInput, CreateIdeaScoreMutationVariables, UpdateIdeaScoreMutationVariables, UpdateIdeaScoreInput, UpdateIdeaMutationVariables, UpdateIdeaCategoryMutationVariables, UpdateIdeaCategoryInput, CreateIdeaSupporterMutationVariables, ListIdeaSupportersQueryVariables, DeleteIdeaSupporterMutationVariables, SearchChatGPTMutationVariables, DeleteIdeaPledgeMutationVariables, CreateIdeaCommentInput, GetIdeaPledgeQueryVariables } from './../API';

import { ListIdeaCategorysQueryVariables,GetIdeaQueryVariables,CreateIdeaPledgeMutationVariables,CreateIdeaPledgeInput,CreateIdeaInput, ListIdeaHashtagsQueryVariables,CreateIdeaMutationVariables } from '../API';
import { buildVariables } from '../libs/GraphQueryBuilder';
import { mutation, query } from "gql-query-builder";

import API, { GraphQLResult } from '@aws-amplify/api';
import { resolve6 } from 'dns';
import { String } from 'aws-sdk/clients/batch';
import { getIdeaPledge } from '../graphql/queries';

export function listIdeaSupporters(fields: any[], _variables?: ListIdeaSupportersQueryVariables) {
  if (!_variables) {
      _variables = {};
  }

  const variables = buildVariables<ListIdeaSupportersQueryVariables>(_variables, [
      { key: "filter", name: "ModelIdeaSupporterFilterInput!" },
      { key: "limit", name: "Int" },
  ]);

  const q = query({
      operation: "result: listIdeaSupporters",
      fields,
      variables,
  });
  return API.graphql(q);
}
export function listIdeaCategorys(fields: any[], _variables?: ListIdeaCategorysQueryVariables) {
    if (!_variables) {
        _variables = {};
    }

    const variables = buildVariables<ListIdeaCategorysQueryVariables>(_variables, [
        { key: "filter", name: "ModelIdeaCategoryFilterInput!" },
        { key: "limit", name: "Int" },
    ]);

    const q = query({
        operation: "result: listIdeaCategorys",
        fields,
        variables,
    });
    return API.graphql(q);
}

export async function getIdeaById(fileds:any,id:string){
  const q: any = getIdeaByIDQuery(fileds, { id: id });
  const idea: any = await API.graphql(q);
  return idea
}

export function getIdeaByIDQuery(
  fields: any[],
  _variables: GetIdeaQueryVariables
) {
  const variables = buildVariables<GetIdeaQueryVariables>(_variables, [
    { key: "id", name: "ID!" }
  ]);
  return query({
    operation: "result: getIdea",
    fields,
    variables,
  });
}

export async function getIdeaPledgeByIDQuery(
  fields: any[],
  _variables: GetIdeaPledgeQueryVariables
) {
  const variables = buildVariables<GetIdeaPledgeQueryVariables>(_variables, [
    { key: "id", name: "ID!" }
  ]);
  const q= query({
    operation: "result: getIdeaPledge",
    fields,
    variables,
  });
  return await API.graphql(q);

}

export function createIdeaPledge(
    fields: any[],
    ideaPledgeInput:CreateIdeaPledgeInput
  ) {
    const _variables: CreateIdeaPledgeMutationVariables = {
        input: {
          ...ideaPledgeInput
        },
      };
    const variables = buildVariables<CreateIdeaPledgeMutationVariables>(_variables, [
      { key: "input", name: "CreateIdeaPledgeInput!" },
      { key: "condition", name: "ModelIdeaPledgeConditionInput" },
    ]);
    return API.graphql( mutation({
        operation: "result: createIdeaPledge",
        fields,
        variables,
      }));
    
  }

  export function createComment(
    fields: any[],
    ideaCommentInput:CreateIdeaCommentInput
  ) {
    const _variables: CreateIdeaCategoryMutationVariables = {
        input: {
          ...ideaCommentInput
        },
      };
    const variables = buildVariables<CreateIdeaCategoryMutationVariables>(_variables, [
      { key: "input", name: "CreateIdeaCommentInput!" },
      { key: "condition", name: "ModelIdeaCommentConditionInput" },
    ]);
    return API.graphql( mutation({
        operation: "result: createIdeaComment",
        fields,
        variables,
      }));
  }
  
  export function updateCategory( fields: any[],
    body:UpdateIdeaCategoryInput,
   ){

   
      const _variables: UpdateIdeaCategoryMutationVariables = {
        input: {
          ...body,
          
        id:body.id
        },
      };
    const variables = buildVariables<UpdateIdeaCategoryMutationVariables>(_variables, [
      { key: "input", name: "UpdateIdeaCategoryInput!" },
      { key: "condition", name: "ModelIdeaCategoryConditionInput" },
      { key: "id", name: "ID!" },
    ]);
    return API.graphql( mutation({
        operation: "result: updateIdeaCategory",
        fields,
        variables,
      }));
    
    }
  export function updateScore( fields: any[],
    body:UpdateIdeaScoreInput,
   ){

   
      const _variables: UpdateIdeaScoreMutationVariables = {
        input: {
          ...body,
          
        id:body.id
        },
      };
    const variables = buildVariables<UpdateIdeaScoreMutationVariables>(_variables, [
      { key: "input", name: "UpdateIdeaScoreInput!" },
      { key: "condition", name: "ModelIdeaScoreConditionInput" },
      { key: "id", name: "ID!" },
    ]);
    return API.graphql( mutation({
        operation: "result: updateIdeaScore",
        fields,
        variables,
      }));
    
    }

  export async function createScore(
    fields: any[],
    body:CreateIdeaScoreInput
  ) {

    const _variables: CreateIdeaScoreMutationVariables = {
        input: {
          ...body
        },
      };
    const variables = buildVariables<CreateIdeaScoreMutationVariables>(_variables, [
      { key: "input", name: "CreateIdeaScoreInput!" },
      { key: "condition", name: "ModelIdeaScoreConditionInput" },
    ]);
    return API.graphql( mutation({
        operation: "result: createIdeaScore",
        fields,
        variables,
      }));
    
  }



  export async function getSumAPI() {
    const _variables: GetIdeaSummaryMutationVariables = {
      input: {
        companyID: '',
      },
    };
    const variables = buildVariables<GetIdeaSummaryMutationVariables>(_variables, [
      { key: "input", name: "GetIdeaSummaryInput!" },
    ]);
    const q = mutation({
      operation: "result: getIdeaSummary",
      fields: [],
      variables,
    });
  
    return API.graphql(q);
  }

  export async function chatGpt(value:string) {
    const _variables: SearchChatGPTMutationVariables = {
      input: {
       search:value
      },
    };
    const variables = buildVariables<SearchChatGPTMutationVariables>(_variables, [
      { key: "input", name: "ChatGPTInput!" },
    ]);
    const q = mutation({
      operation: "result: searchChatGPT",
      fields: [],
      variables,
    });
  
    return API.graphql(q);
  }
  
  export async function getSum() {
    return ((await getSumAPI()) as GraphQLResult<{ result: any }>).data?.result;
  }

  
export async function createNewIdea(
    fields: any[],
    ideaInput: any
  ) {
const pledges=JSON.parse(JSON.stringify(ideaInput.pledges))

delete ideaInput.pledges
    const _variables: CreateIdeaMutationVariables = {
      input: {
        ...ideaInput
      },
    };
    console.log(_variables)
    const q = createIdeaQuery(fields, _variables);
   const res=await API.graphql(q) as any;
   await Promise.all( pledges.options.map((item:any)=>{
    createIdeaPledge(['id'],{...item,currency:'SGD',ideaID:res?.data?.result.id,id:undefined})
   }))
   return res
    
  }

  export async function updateIdea(
    fields: any[],
    ideaInput: any,
    id:String,
    pledgeChange:any
  ) {
    console.log(ideaInput)
    // if(ideaInput.pledges){

    // }
    const _variables: UpdateIdeaMutationVariables = {
      input: {
        ...ideaInput,
        id,
        pledges:undefined
      },
      
    };
    const q = updateIdeaQuery(fields, _variables);
    const res= await API.graphql(q)
  
    if(pledgeChange){
      await Promise.all([...ideaInput.pledges.options.map((item:any)=>createIdeaPledge(['id'],{...item,currency:'SGD',ideaID:id})
       ),...pledgeChange.items.map((item:any)=>deletePledgeQuery(item.id))])
     
    }
    return res
  }

  export function updateIdeaQuery(
    fields: any[],
    _variables: UpdateIdeaMutationVariables
  ) {
    const variables = buildVariables<UpdateIdeaMutationVariables>(_variables, [
      { key: "input", name: "UpdateIdeaInput!" },
      { key: "condition", name: "ModelIdeaConditionInput" },
      { key: "id", name: "ID!" },
    ]);
  
    return mutation({
      operation: "result: updateIdea",
      fields,
      variables,
    });
  }
  
export function createIdeaQuery(
    fields: any[],
    _variables: CreateIdeaMutationVariables
  ) {
    const variables = buildVariables<CreateIdeaMutationVariables>(_variables, [
      { key: "input", name: "CreateIdeaInput!" },
      { key: "condition", name: "ModelIdeaConditionInput" },
    ]);
  
    return mutation({
      operation: "result: createIdea",
      fields,
      variables,
    });
  }
  export async function deletePledgeQuery(
   id:string
  ){
    const _variables: DeleteIdeaPledgeMutationVariables = {
      input: {
        id
      }
    };
    const variables = buildVariables<DeleteIdeaPledgeMutationVariables>(_variables, [
      { key: "input", name: "DeleteIdeaPledgeInput!" },
    ]);
  
    const q= mutation({
      operation: "result: deleteIdeaPledge",
      fields:['title'],
      variables,
    });
    return API.graphql(q);
  }

  export function addCategory(
    fields:any[],
    input:any
   ) {
     const _variables: CreateIdeaCategoryMutationVariables = {
       input: {
         ...input
       }
     };
     const variables = buildVariables<CreateIdeaCategoryMutationVariables>(_variables, [
       { key: "input", name: "CreateIdeaCategoryInput!" },
       { key: "condition", name: "ModelIdeaCategoryConditionInput" },
     ]);
   
     const q= mutation({
       operation: "result: createIdeaCategory",
       fields,
       variables,
     });
     return API.graphql(q);
   }

   export function addSupporter(
    fields:any[],
    input:any
   ) {
     const _variables: CreateIdeaSupporterMutationVariables = {
       input: {
         ...input
       }
     };
     const variables = buildVariables<CreateIdeaSupporterMutationVariables>(_variables, [
       { key: "input", name: "CreateIdeaSupporterInput!" },
       { key: "condition", name: "ModelIdeaSupporterConditionInput" },
     ]);
   
     const q= mutation({
       operation: "result: createIdeaSupporter",
       fields,
       variables,
     });
     return API.graphql(q);
   }


  

   export function addHashtag(
    fields:any[],
    input:any
   ) {
     const _variables: CreateIdeaHashtagMutationVariables = {
       input: {
         ...input
       }
     };
     const variables = buildVariables<CreateIdeaHashtagMutationVariables>(_variables, [
       { key: "input", name: "CreateIdeaHashtagInput!" },
       { key: "condition", name: "ModelIdeaHashtagConditionInput" },
     ]);
   
     const q= mutation({
       operation: "result: createIdeaHashtag",
       fields,
       variables,
     });
     return API.graphql(q);
   }
   export function deleteHashtagQuery(
    id:string
   ) {
     const _variables: DeleteIdeaHashtagMutationVariables = {
       input: {
         id
       }
     };
     const variables = buildVariables<DeleteIdeaHashtagMutationVariables>(_variables, [
       { key: "input", name: "DeleteIdeaHashtagInput!" },
     ]);
   
     const q= mutation({
       operation: "result: deleteIdeaHashtag",
       fields:['title'],
       variables,
     });
     return API.graphql(q);
   }
  export function deleteCategoryQuery(
   id:string
  ) {
    const _variables: DeleteIdeaCategoryMutationVariables = {
      input: {
        id
      }
    };
    const variables = buildVariables<DeleteIdeaCategoryMutationVariables>(_variables, [
      { key: "input", name: "DeleteIdeaCategoryInput!" },
    ]);
  
    const q= mutation({
      operation: "result: deleteIdeaCategory",
      fields:['title'],
      variables,
    });
    return API.graphql(q);
  }

  export function deleteSupporterQuery(
    id:string
   ) {
     const _variables: DeleteIdeaSupporterMutationVariables = {
       input: {
         id
       }
     };
     const variables = buildVariables<DeleteIdeaSupporterMutationVariables>(_variables, [
       { key: "input", name: "DeleteIdeaSupporterInput!" },
     ]);
   
     const q= mutation({
       operation: "result: deleteIdeaSupporter",
       fields:['url'],
       variables,
     });
     return API.graphql(q);
   }

export function listIdeaHashtags(fields: any[], _variables?: ListIdeaHashtagsQueryVariables) {
    if (!_variables) {
        _variables = {};
    }

    const variables = buildVariables<ListIdeaHashtagsQueryVariables>(_variables, [
        { key: "filter", name: "ModelIdeaHashtagFilterInput!" },
        { key: "limit", name: "Int" },
    ]);

    const q = query({
        operation: "result: listIdeaHashtags",
        fields,
        variables,
    });
    return API.graphql(q);
}
export function listIdea(fields: any[], _variables?: ListIdeasQueryVariables) {
  if (!_variables) {
      _variables = {};
  }

  const variables = buildVariables<ListIdeasQueryVariables>(_variables, [
      { key: "filter", name: "ModelIdeaFilterInput!" },
      { key: "limit", name: "Int" },
  ]);

  const q = query({
      operation: "result: listIdeas",
      fields,
      variables,
  });
  return API.graphql(q);
}
